/**
 * 監査ログ（オペレーター向け）。画面は顧客向けと同じものを使う。
 *
 * **全テナント横断は出せない。** 台帳の pk にテナントが必ず入るので（NFR6）、
 * 会社をまたいで 1 回で読む経路が無い。いま選んでいる会社のぶんが出る、と
 * 画面に書いてある。
 */

import { AuditLogScreen } from "visumo-data-agent-web-shared";

import { HelpIcon } from "../help/index";
import { useViewer } from "../ViewerContext";

export function AuditPage() {
  const viewer = useViewer();
  return (
    <AuditLogScreen
      description="操作の記録です。新しい順に並びます。"
      help={<HelpIcon slug="audit/log" />}
      note={
        <>
          <strong>
            いま開いている会社（{viewer.tenant.label}）のぶんだけです。
          </strong>
          会社をまたいで記録を並べる画面はありません。別の会社の記録を見るには、
          会社を切り替えてください。
        </>
      }
    />
  );
}
